import { create } from 'zustand';
import type { ImpersonationContext } from './impersonationSession';

type ImpersonationState = {
  context: ImpersonationContext | null;
  loading: boolean;
  setContext: (context: ImpersonationContext | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
};

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  context: null,
  loading: false,
  setContext: (context) => set({ context, loading: false }),
  setLoading: (loading) => set({ loading }),
  clear: () => set({ context: null, loading: false }),
}));

export function isImpersonating(): boolean {
  return useImpersonationStore.getState().context != null;
}
